export default __webpack_public_path__ + "static/media/consultation.231ff018.svg";